/**
 * Section headings for the left navigation rail.
 *
 * Kept in its own module so nav-item definitions can label themselves without
 * importing the whole dashboard config (and vice versa).
 */
export const NAV_SECTIONS = {
  BUILD: "Build",
  CONNECT: "Connect",
  OBSERVE: "Observe",
  CONFIGURE: "Configure",
  ACCOUNT: "Account",
};

/** Order in which sections are rendered in the rail. */
export const NAV_SECTION_ORDER = [
  NAV_SECTIONS.BUILD,
  NAV_SECTIONS.CONNECT,
  NAV_SECTIONS.OBSERVE,
  NAV_SECTIONS.CONFIGURE,
  NAV_SECTIONS.ACCOUNT,
];
